import { Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[zxImageAutoFix]'
})
export class ImageAutoFixDirective {
    width: number;
    height: number;
    element: any;
    constructor(
        private elementRef: ElementRef,
    ) {
        elementRef.nativeElement.onload = function () {
            this.element = elementRef.nativeElement;
            this.width = this.element.naturalWidth;
            this.height = this.element.naturalHeight;
            if (this.width <= elementRef.nativeElement.parentElement.clientWidth) {
                this.element.style.height = '100%';
                this.element.style.width = 'auto';
                if (this.height <= elementRef.nativeElement.parentElement.clientHeight) {
                    this.element.style.width = 'auto';
                    this.element.style.height = '100%';
                } else {
                    this.element.style.width = '100%';
                    this.element.style.height = 'auto';
                }
            } else {
                this.element.style.width = '100%';
                this.element.style.height = 'auto';
                if (this.height <= elementRef.nativeElement.parentElement.clientHeight) {
                    this.element.style.width = 'auto';
                    this.element.style.height = '100%';
                } else {
                    this.element.style.width = '100%';
                    this.element.style.height = 'auto';
                }
            }
        };
    }
}
